export const WATERFALL_SLUG = 'waterfall';